import { render, staticRenderFns } from "./extractedDataViewer.vue?vue&type=template&id=28e9fe86&scoped=true&"
import script from "./extractedDataViewer.vue?vue&type=script&lang=js&"
export * from "./extractedDataViewer.vue?vue&type=script&lang=js&"
import style0 from "./extractedDataViewer.vue?vue&type=style&index=0&id=28e9fe86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e9fe86",
  null
  
)

export default component.exports